import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import EfImg from '../ef-img';
import EfLink from '../ef-link';
import gtm from '@/utils/gtm';
import './index.scss';
interface EfTabHoverAItemProps {
    /**
     * 所有分辨率展示的图片链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024时展示的图片链接
     */
    h5?: string;
    /**
     * tabName
     */
    tabName?: string;
    /**
     * label
     */
    label?: string;
    /**
     * 标题
     */
    title?: React.ReactNode;
    /**
     * desc
     */
    descList?: string[];
    /**
     * moreIcon
     */
    moreIcon?: React.ReactNode;
    /**
     * moreLink
     */
    moreLink?: string;
    /**
     * moreText
     */
    moreText?: string;
    /**
     * more 链接的埋点
     */
    moreDataLayer?: any[];
    /**
     * buyIcon
     */
    buyIcon?: React.ReactNode;
    /**
     * buyLink
     */
    buyLink?: string;
    /**
     * buyText
     */
    buyText?: string;
    /**
     * buy 按钮状态
     */
    buyBtnDisabled?: boolean;
    /**
     * buy 链接的埋点
     */
    buyDataLayer?: any[];
    /**
     * 样式名
     */
    className?: string;
    /**
     * buyText
     */
    tips?: string;
}
interface EfTabHoverAProps {
    /**
     * 列表
     */
    items: EfTabHoverAItemProps[];
    /**
     * 切换回调
     */
    callback?: (item: EfTabHoverAItemProps) => void;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 */
const EfTabHoverA: React.FC<EfTabHoverAProps> = ({ items = [], callback }) => {
    const prefixCls = `ef-tab-hover-a`;
    const isShowTab = items.length > 1;
    const domRef = useRef<any>(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeItem, setActiveItem] = useState(items[0] || {});
    const classes = classNames(prefixCls, 'ef-container', {
        [`${prefixCls}-tab-bar`]: isShowTab,
    });

    // 点击切换
    const clickHandle = (item: EfTabHoverAItemProps, index: number) => {
        setActiveItem(item);
        setActiveIndex(index);
        callback && callback(item);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: item.title || 'none',
            button_name: item.tabName,
        });
    };

    const isElementInViewport = (element: any) => {
        const rect = element.getBoundingClientRect();
        return rect.left >= 0 && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    };

    const onTouchMove = () => {
        setTimeout(() => {
            const domLeft = domRef.current?.querySelector('.item0');
            const domRight = domRef.current?.querySelector('.item1');
            const showLeft = isElementInViewport(domLeft);
            const showRight = isElementInViewport(domRight);
            if (showLeft) {
                callback?.(items[0]);
            }
            if (showRight) {
                callback?.(items[1]);
            }
        }, 500);
    };

    // 坑啊 高度遮挡就不能触发
    // const observeElementVisibility = (element: any) => {
    //     const observer = new IntersectionObserver(
    //         (entries) => {
    //             entries.forEach((entry) => {
    //                 if (entry.isIntersecting && entry.intersectionRatio === 1) {
    //                     callback?.(items[0]);
    //                 } else {
    //                     callback?.(items[1]);
    //                 }
    //             });
    //         },
    //         { threshold: [1.0] },
    //     ); // 设置阈值为1.0表示元素100%可见时触发
    //     observer.observe(element);
    // };

    useEffect(() => {
        // observeElementVisibility(domRef.current?.querySelector('.item0'));
    }, []);

    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`} onTouchMove={onTouchMove} ref={domRef}>
                {items?.map((item: EfTabHoverAItemProps, index: number) => (
                    <div className={`${prefixCls}-item${activeIndex === index ? ` ${prefixCls}-item-active` : ''} item${index}`} key={index}>
                        <div className={`${prefixCls}-img`}>
                            <EfImg pc={item.pc} h5={item.h5} />
                        </div>
                        <div className={`${prefixCls}-msg`}>
                            <div className={`${prefixCls}-msg-in`}>
                                {item.label && <div className={`${prefixCls}-label`}>{item.label}</div>}
                                {item.title && <div className={`${prefixCls}-title`}>{item.title}</div>}
                                {item.descList && (
                                    <ul className={`${prefixCls}-desc`}>
                                        {item?.descList?.map((item: string, index: number) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                                <div className={`${prefixCls}-btn-box`}>
                                    {item.moreLink && (
                                        <EfLink href={item.moreLink} className={`${prefixCls}-link ${prefixCls}-moreLink`} dataLayer={item.moreDataLayer}>
                                            {item.moreIcon}
                                            {item.moreText}
                                        </EfLink>
                                    )}
                                    {item.buyLink && (
                                        <EfLink
                                            href={item.buyLink}
                                            className={`${prefixCls}-link ${prefixCls}-buyLink${item.buyBtnDisabled ? ` ${prefixCls}-link-disabled` : ''}`}
                                            dataLayer={item.buyDataLayer}
                                        >
                                            {item.buyIcon}
                                            {item.buyText}
                                        </EfLink>
                                    )}
                                </div>
                                <div className={`${prefixCls}-tips`}>{item.tips}</div>
                            </div>
                        </div>
                    </div>
                ))}
                {isShowTab && (
                    <div className={`${prefixCls}-tab`}>
                        <div className={`${prefixCls}-tab-in`}>
                            {items?.map((item: EfTabHoverAItemProps, index: number) => (
                                <div
                                    key={index}
                                    className={`${prefixCls}-h-item${item.tabName === activeItem.tabName ? ` ${prefixCls}-h-item-active` : ''}`}
                                    onClick={() => clickHandle(item, index)}
                                >
                                    {item.tabName}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EfTabHoverA;
